import React, { useState } from 'react';
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Select from '@mui/material/Select';
import CloseIcon from "@mui/icons-material/Close";
import WorkIcon from '@mui/icons-material/Work';

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 430,
  bgcolor: "background.paper",
  border: "2px solid #E2E8F0",
  borderRadius: "15px",
  boxShadow: 24,
  p: 4,
};

function TimeClockRoleSelectionModal(props) {
  const {
    open,
    handleClose,
    roleSelectionList,
    handleClockIn
  } = props;

  const [selectedRole, setSelectedRole] = useState("");

  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const handleSubmit = () => {
    handleClockIn(selectedRole);
    handleClose();
  };

  const handleModalClose = () => {
    setSelectedRole("");
    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleModalClose}
      aria-labelledby="role-selection-modal-title"
      aria-describedby="role-selection-modal-description"
    >
      <Box sx={style}>
        <div>
          <div className="absolute right-2 top-2">
            <IconButton
              className="text-gray-400 hover:text-gray-600"
              onClick={handleModalClose}
              size="small"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </div>

          <div>
            <div className="mb-6">
              <div className="flex items-center space-x-3 mb-2">
                <WorkIcon className="text-violet-600" />
                <h3 className="text-xl font-semibold text-gray-900">
                  Select your role
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Please select the role you'll be working as for this shift.
              </p>
            </div>

            <div className="mb-6">
              <Select
                fullWidth
                name="selected_role"
                value={selectedRole}
                onChange={handleRoleChange}
                sx={{
                  backgroundColor: "white",
                  borderRadius: "10px",
                  height: "50px",
                  ".MuiOutlinedInput-notchedOutline": {
                    borderWidth: "1px",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#6d28d9",
                  },
                }}
                displayEmpty
              >
                <MenuItem value="" disabled>
                  <em style={{ color: 'rgba(0, 0, 0, 0.38)' }}>Select Role</em>
                </MenuItem>
                {roleSelectionList?.map((option) => (
                  <MenuItem key={option.scheduled_role} value={option.scheduled_role_obj.id}>
                    {option.scheduled_role_obj.role_name}
                  </MenuItem>
                ))}
              </Select>
            </div>

            <div className="flex items-center space-x-3">
              <button
                className={`flex-1 px-4 py-3 rounded-lg ${
                  selectedRole
                    ? "bg-emerald-500 hover:bg-emerald-600 text-white transition-colors duration-200"
                    : "bg-gray-100 text-gray-400 cursor-not-allowed"
                } text-sm font-medium flex items-center justify-center space-x-2`}
                onClick={selectedRole ? handleSubmit : undefined}
                disabled={!selectedRole}
              >
                <span>Clock In</span>
              </button>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default TimeClockRoleSelectionModal;
